function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (prefix) {
  var suffixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['_COMPLETED', '_SUCCEEDED', '_FAILED'];
  var modulePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var types = _defineProperty({}, prefix, modulePrefix ? modulePrefix + '/' + prefix : prefix);

  suffixes.forEach(function (suffix) {
    var type = '' + prefix + suffix;
    types[type] = modulePrefix ? modulePrefix + '/' + type : type;
  });
  return types;
});